module.exports = __webpack_public_path__ + "img/change-password.13dca7d4.svg";